import React from 'react';
import PropTypes from 'prop-types';

const ListingInformation = ({ Description, Url, UrlText, HealthSelectionLink }) => {
  const matomoTrackingClass = 'lista-dig-på-en-mottagning';
  return (
    <div className="listing-information">
      <p>{Description}</p>
      {HealthSelectionLink && (
        <a className="listing-information__healthselection-link" href={HealthSelectionLink.url}>
          {HealthSelectionLink.text}
        </a>
      )}
      <div className="listing-information__link__container">
        <a className={`listing-information__link ${matomoTrackingClass}`} href={Url} id="listing-link">
          <span>{UrlText}</span>
        </a>
      </div>
    </div>
  );
};

ListingInformation.propTypes = {
  Description: PropTypes.string,
  Url: PropTypes.string,
  UrlText: PropTypes.string,
  HealthSelectionLink: PropTypes.shape({
    url: PropTypes.string,
    text: PropTypes.string,
  }),
};

export default ListingInformation;
